import { useState }           from 'react';
import ChangeApprovedModal    from './ChangeApprovedModal';
import LinkToApp              from './LinkToApp';
import { contentInfoType }    from 'types';
import { makeStyles }         from 'makeStyles';
import { colors }             from 'utils/colors';


const useStyles = makeStyles()(() => ({
    imageContainer: {
      width:           '100%',
      height:          '100%',
      cursor:          'pointer',
      display:         'flex',
      alignItems:      'center',
      justifyContent:  'space-evenly',
      flexFlow:        'column',
      textDecoration:  'none'
    },
    image: {
      height:             '60%',
      width:              '90%',
      backgroundPosition: 'center',
      backgroundSize:     'contain',
      backgroundRepeat:   'no-repeat',
  },
  name: {
    height:         '20%',
    width:          '90%',
    display:        'flex',
    alignItems:     'center',
    justifyContent: 'flex-end',
    flexFlow:       'column',
    textAlign:      'center',
    fontSize:        16,
    fontWeight:     'bold',
    color:          colors.darkText
  },
  grades: {
    height:         '10%',
    width:          '90%',
    display:        'flex',
    alignItems:     'center',
    justifyContent: 'flex-end',
    flexFlow:       'column',
    textAlign:      'center',
    borderBottom:   10
  },
  showApproved: { 
    border: '1px solid #00F',
    cursor: 'pointer'
  }
}))

type ImageContainerProps = {
  appName:         string;
  path:            string;
  guest:           boolean;
  disabled:        boolean;
  showApproved:    boolean;
  val:             contentInfoType;
}

const ImageContainer: React.FC<ImageContainerProps> = ({
  appName,
  path,
  guest,
  disabled,
  showApproved,
  val
}) => {

  const { classes } = useStyles();
  const [showApprovedModal, setShowApprovedModal] = useState(false)
  
  return (
    <>
         {
            showApproved && !!val.approved &&
            <div 
               className = { classes.showApproved }
               onClick   = { () => setShowApprovedModal(true) }
            >
              { `approved : ${ val.approved }` }
            </div>
         }
          <LinkToApp
            appName       = { appName }
            guest         = { guest }
            disabled      = { disabled }
            path          = { path }
            val           = { val }
          />
         {
          showApprovedModal &&
           <ChangeApprovedModal
             id                   = { val.id }
             approved             = { val.approved }
             setShowApprovedModal = { setShowApprovedModal }
         />
         }
    </>
  );
}


export default ImageContainer;



